export default __webpack_public_path__ + "static/5-projects-pest-control-6b725f2a6f7fd038818b06aa51e82ee4.jpg";